export enum DishTierEnum {
    QUICK = "QUICK",
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
    SUPER_HIGH = "SUPER_HIGH",
}
